<template>
  <div>
    <!-- for class -->
    <div class="row">
      <label :class="['col-form-label', colClassLeft]">{{ labelText }}</label>
      <div :class="colClassRight">
        <input
          class="form-control"
          type="datetime-local"
          :value="modelValue"
          @input="$emit('update:modelValue', $event.target.value)"
          :disabled="disabled"
        />
      </div>
    </div>
  </div>
</template>

<script>
// moved out of DatetimeInput.js verbatim - options API, there is no setup() to lift
export default {
  name: "DatetimeInput",
  emits: ["update:modelValue"],
  props: {
    labelText: { type: String },
    modelValue: { type: String },
    disabled: { type: Boolean, default: false },
    colClassLeft: { type: String, default: "col-sm-3" },
    colClassRight: { type: String, default: "col-sm-9" },
  },
}
</script>
